import { ReceiversRepository } from '../repositories/receivers.repository'
import {
    ReceiverPayloadT,
    ReceiversCreateReceiverResponseT,
    ReceiversGetListResponseT,
    ReceiversSearchParamT,
    ReceiversSearchReceiverResponseT,
} from '../types/receivers.types'
import { AdditionalServicesI, AdditionalServicesLTLI } from '@/core/types/additional_services.types'

const receiversRepository = new ReceiversRepository()

export class ReceiversService {
    async getList(
        page: number,
        sender_city_id: number,
        company_id: number
    ): Promise<ReceiversGetListResponseT> {
        const response = await receiversRepository.getList(page, sender_city_id, company_id)
        return response.data
    }

    async getListWithoutCityId(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<ReceiversGetListResponseT> {
        const response = await receiversRepository.getListWithoutCityId(page, company_id, city_id)
        return response.data
    }

    async getListFtl(
        page: number,
        company_id: number,
        city_id?: number
    ): Promise<ReceiversGetListResponseT> {
        const response = await receiversRepository.getListFtl(page, company_id, city_id)
        return response.data
    }

    async createReceiver(payload: ReceiverPayloadT): Promise<ReceiversCreateReceiverResponseT> {
        const response = await receiversRepository.createReceiver(payload)
        return response.data
    }

    async updateReceiver(
        id: number,
        payload: ReceiverPayloadT
    ): Promise<ReceiversCreateReceiverResponseT> {
        const response = await receiversRepository.updateReceiver(id, payload)
        return response.data
    }

    async updateAdditionalServices(id: number, payload: AdditionalServicesLTLI): Promise<void> {
        const response = await receiversRepository.updateAdditionalServices(id, payload)
        return response.data
    }

    async updateReceiverInOrder(id: number, payload: ReceiverPayloadT): Promise<void> {
        const response = await receiversRepository.updateReceiverInOrder(id, payload)
        return response.data
    }

    async deleteReceiver(id: number): Promise<void> {
        await receiversRepository.deleteReceiver(id)
    }

    async searchReceiver(params: ReceiversSearchParamT): Promise<ReceiversSearchReceiverResponseT> {
        const response = await receiversRepository.searchReceiver(params)
        return response.data
    }
}
